module.exports = __webpack_public_path__ + "media/images/country_flags/me-0d23fb9345609c5054c5374a53529c1e.png";